if (!customElements.get('custom-dropdown-value')) {
  class CustomDropdownValue extends HTMLElement {
    constructor() {
      super();

      this.updateInnerHTMLRef = this.updateInnerHTML.bind(this);
    }

    updateInnerHTML(event) {
      if(event.detail.id != this.getAttribute('data-id')) return;
      this.innerHTML = event.detail.html.replace('label', 'span');
    }

    disconnectedCallback() {
      document.removeEventListener('rocket:update-custom-dropdown-value', this.updateInnerHTMLRef);
    }

    connectedCallback() {
      document.addEventListener('rocket:update-custom-dropdown-value', this.updateInnerHTMLRef);
    }
  }

  customElements.define('custom-dropdown-value', CustomDropdownValue);
}
